import React, { useState } from "react";
import { Link } from "react-router-dom";
import { apiPost } from "../../../api";
import "../../../App.css";
import "../styles/ForgotPassword.css";

import studentForgot from "../../../images/student-forgot-password.png";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setMsg("");
    setIsSuccess(false);
    setLoading(true);
    try {
      const res = await apiPost("/auth/forgot-password", { email });
      setMsg(res.message);
      setIsSuccess(true);
    } catch (err) {
      setMsg(err.message || "Error");
      setIsSuccess(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-page">
      <img
        src={studentForgot}
        alt="Forgot illustration"
        className="forgot-illustration"
      />
      <div className="forgot-box">
        <h1 className="forgot-title">Forgot Password</h1>

        <form onSubmit={onSubmit} className="forgot-form">
          <label>Email</label>
          <input
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="yourname@my.yorku.ca"
          />

          <button type="submit" className="primary-btn" disabled={loading}>
            {loading ? <span className="spinner"></span> : "Send Reset Link"}
          </button>
        </form>

        {msg && <p className={`msg ${isSuccess ? "success" : "error"}`}>{msg}</p>}

        <div className="forgot-links">
          <p>
            <Link to="/auth/react/signin" className="link">
              Sign In
            </Link>{" "}
            |{" "}
            <Link to="/auth/react/register" className="link">
              Register
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}